import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
import VueAxios from 'vue-axios'
import './registerServiceWorker'

// Global styles - Design System
import './assets/styles/variables.css'
import './assets/styles/animations.css'
import './assets/styles/element-overrides.css'

Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(VueAxios , axios)

axios.defaults.baseURL = 'https://api.hooopex.com'
axios.defaults.withCredentials = true

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')




